import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Heading from './Title';
import Btnbook from './Btnbook';
import './Home.css';

export default function Home({ isAuthenticated }) {
    const navigate = useNavigate();

    // Handler for Book Now button click
    const handleBookNowClick = () => {
        if (isAuthenticated) {
            // If user is authenticated, redirect to booking page
            navigate('/booking');
        } else {
            // If user is not authenticated, redirect to login page
            navigate('/login', { state: { redirectTo: '/booking' } });
        }
    };

    // Scroll to top when component mounts
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="home-container">
            <Heading />
            <Btnbook onBookNow={handleBookNowClick} />
        </div>
    );
}



